import Helmet from 'react-helmet'
import { Outlet } from 'react-router-dom'
import Header from './components/Header'
import styles from './index.module.scss'

export default () => {
  return (
    <>
      <Helmet>
        <title>恋爱帮-脱单有人帮 就上恋爱帮！</title>
        <meta name="description" content="恋爱帮-专业婚恋经纪人服务平台，采用了线上线下相结合的服务模式，通过“会员+经纪人+服务中心+平台”的全国共享模式为您精心牵线，帮助您找到理想的另一半。加入我们，开启您的幸福恋爱之旅，体验专业、真实可靠、高质量的婚恋服务…" />
        <meta name="keywords" content="恋爱技巧、脱单咨询、单身派对、交友活动、约会服务、最佳婚恋平台、婚恋规划师服务、专业婚恋经纪人" />
      </Helmet>
      <div className={styles.main}>
        {/* <Header /> */}
        <Outlet />
        {/* <div className={styles.footer}>
          <a href={'https://beian.miit.gov.cn'} target="_blank" rel="noreferrer"></a>
          <p>恋爱帮</p>
        </div> */}
      </div>
    </>
  )
}
